export const environment = {
  CurrencyAPIKey: '1e1b900ce938c258db6ce5e7ee234980',
  production: false,
  webAPIKey: 'ek0RLNtEeUawzwtTXRC1HieJESxEzwYI',
   //serverUrl: 'http://localhost:51594/api/',
  serverUrl:'https://adventumcalapi.onerooftechnologies.com/api/',
  PropertyDataKey:"ZZZ0Z1MM80"
};
